import { render, staticRenderFns } from "./bedchart-content.vue?vue&type=template&id=34aed308&scoped=true"
import script from "./bedchart-content.vue?vue&type=script&lang=js"
export * from "./bedchart-content.vue?vue&type=script&lang=js"
import style0 from "./bedchart-content.vue?vue&type=style&index=0&id=34aed308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aed308",
  null
  
)

export default component.exports